import { render, staticRenderFns } from "./Consultant.vue?vue&type=template&id=2c4ca29a&"
import script from "./Consultant.vue?vue&type=script&lang=js&"
export * from "./Consultant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports